import { render, staticRenderFns } from "./withdraw-kpi-detail.vue?vue&type=template&id=9ca1888a&scoped=true&"
import script from "./withdraw-kpi-detail.vue?vue&type=script&lang=js&"
export * from "./withdraw-kpi-detail.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-kpi-detail.vue?vue&type=style&index=0&id=9ca1888a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca1888a",
  null
  
)

export default component.exports